import { axios } from "@cores/axiosWrapper";

export function getPromptPresetsAPI(apiEndpoint, projectId, params = {}) {
    return axios.get(`${apiEndpoint}/gen-ai/prompt-presets`, {
        params,
        headers: {
            projectId,
        },
    });
}

export function createPromptPresetAPI(apiEndpoint, projectId, data) {
    return axios.post(`${apiEndpoint}/gen-ai/prompt-presets`, data, {
        headers: {
            projectId,
        },
    });
}

export function getPromptPresetAPI(apiEndpoint, projectId, presetId) {
    return axios.get(`${apiEndpoint}/gen-ai/prompt-presets/${presetId}`, {
        headers: {
            projectId,
        },
    });
}

export function deletePromptPresetAPI(apiEndpoint, projectId, presetId) {
    return axios.delete(`${apiEndpoint}/gen-ai/prompt-presets/${presetId}`, {
        headers: {
            projectId,
        },
    });
}

export function updatePromptPresetStatusAPI(apiEndpoint, projectId, presetId, data) {
    return axios.put(`${apiEndpoint}/gen-ai/prompt-presets/${presetId}/status`, data, {
        headers: {
            projectId,
        },
    });
}

export function updatePromptPresetAPI(apiEndpoint, projectId, presetId, data) {
    return axios.patch(`${apiEndpoint}/gen-ai/prompt-presets/${presetId}`, data, {
        headers: {
            projectId,
        },
    });
}
